// extracted by mini-css-extract-plugin
export default {"SendMessageForm":"style_SendMessageForm__yTsrT","Btn":"style_Btn__56eGA","Btn_none":"style_Btn_none__BOJvX","Error":"style_Error__5c5o+"};